/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
    name: 'DateFormatsInfoModal',

    props: {
        type: {
            type: String,
            default: 'all'
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-format-info-modal modal-wrapper help-modal"},[_c('div',{staticClass:"modal-header"},[_c('a',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}}),_c('h2',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.modal_title')))])]),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.intro')))]),(_vm.type === 'all' || _vm.type === 'date')?[_c('h4',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.date_formatting')))]),_c('table',{staticClass:"mini"},[_c('thead',[_c('tr',[_c('th',{staticClass:"unit"},[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.unit')))]),_c('th',{staticClass:"token"},[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.token')))]),_c('th',{staticClass:"outcome"},[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.outcome')))])])]),_c('tbody',[_c('tr',{staticClass:"odd"},[_c('td',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.year')))]),_vm._m(0),_c('td',[_vm._v("70 71 ... 10 11")])]),_vm._m(1),_vm._m(2),_c('tr',{staticClass:"even"},[_c('td',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.month')))]),_vm._m(3),_c('td',[_vm._v("1 2 ... 11 12")])]),_vm._m(4),_vm._m(5),_vm._m(6),_c('tr',{staticClass:"odd"},[_c('td',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.day_of_month')))]),_vm._m(7),_c('td',[_vm._v("1 2 ... 30 31")])]),_vm._m(8),_c('tr',{staticClass:"even"},[_c('td',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.day_of_week')))]),_vm._m(9),_c('td',[_vm._v("0 1 ... 5 6")])]),_vm._m(10),_vm._m(11),_vm._m(12)])])]:_vm._e(),(_vm.type === 'all' || _vm.type === 'time')?[_c('h4',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.time_formatting')))]),_c('table',{staticClass:"mini"},[_c('thead',[_c('tr',[_c('th',{staticClass:"unit"},[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.unit')))]),_c('th',{staticClass:"token"},[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.token')))]),_c('th',{staticClass:"outcome"},[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.outcome')))])])]),_c('tbody',[_c('tr',{staticClass:"odd"},[_c('td',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.am_pm')))]),_vm._m(13),_c('td',[_vm._v("AM PM")])]),_vm._m(14),_c('tr',{staticClass:"even"},[_c('td',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.hour')))]),_vm._m(15),_c('td',[_vm._v("0 1 ... 22 23")])]),_vm._m(16),_vm._m(17),_vm._m(18),_c('tr',{staticClass:"odd"},[_c('td',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.minute')))]),_vm._m(19),_c('td',[_vm._v("0 1 ... 58 59")])]),_vm._m(20),_c('tr',{staticClass:"even"},[_c('td',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.second')))]),_vm._m(21),_c('td',[_vm._v("0 1 ... 58 59")])]),_vm._m(22),_c('tr',{staticClass:"odd"},[_c('td',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.fractional_second')))]),_vm._m(23),_c('td',[_vm._v("0 1 ... 8 9")])]),_vm._m(24),_vm._m(25),_c('tr',{staticClass:"even"},[_c('td',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.time_zone')))]),_vm._m(26),_c('td',[_vm._v("-07:00 -06:00 ... +06:00 +07:00")])]),_vm._m(27),_c('tr',{staticClass:"odd"},[_c('td',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.week_of_year')))]),_vm._m(28),_c('td',[_vm._v("1 2 ... 52 53")])]),_vm._m(29),_c('tr',{staticClass:"even"},[_c('td',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.unix_timestamp')))]),_vm._m(30),_c('td',[_vm._v("1360013296")])]),_c('tr',{staticClass:"odd"},[_c('td',[_vm._v(_vm._s(_vm.$t('general.helps.date_formats.unix_millisecond_timestamp')))]),_vm._m(31),_c('td',[_vm._v("1360013296123")])])])])]:_vm._e()],2),_c('div',{staticClass:"modal-footer"},[_c('footer',{staticClass:"actions"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(_vm._s(_vm.$t('general.close')))])])])])}
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("YY")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"odd"},[_c('td'),_c('td',[_c('strong',[_vm._v("YYYY")])]),_c('td',[_vm._v("1970 1971 ... 2010 2011")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"odd"},[_c('td'),_c('td',[_c('strong',[_vm._v("Y")])]),_c('td',[_vm._v("-1000 ...20 ... 1970 ... 9999 +10000")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("M")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"even"},[_c('td'),_c('td',[_c('strong',[_vm._v("MM")])]),_c('td',[_vm._v("01 02 ... 11 12")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"even"},[_c('td'),_c('td',[_c('strong',[_vm._v("MMM")])]),_c('td',[_vm._v("Jan Feb ... Nov Dec")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"even"},[_c('td'),_c('td',[_c('strong',[_vm._v("MMMM")])]),_c('td',[_vm._v("January February ... November December")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("D")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"odd"},[_c('td'),_c('td',[_c('strong',[_vm._v("DD")])]),_c('td',[_vm._v("01 02 ... 30 31")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("d")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"even"},[_c('td'),_c('td',[_c('strong',[_vm._v("dd")])]),_c('td',[_vm._v("Su Mo ... Fr Sa")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"even"},[_c('td'),_c('td',[_c('strong',[_vm._v("ddd")])]),_c('td',[_vm._v("Sun Mon ... Fri Sat")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"even"},[_c('td'),_c('td',[_c('strong',[_vm._v("dddd")])]),_c('td',[_vm._v("Sunday Monday ... Friday Saturday")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("A")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"odd"},[_c('td'),_c('td',[_c('strong',[_vm._v("a")])]),_c('td',[_vm._v("am pm")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("H")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"even"},[_c('td'),_c('td',[_c('strong',[_vm._v("HH")])]),_c('td',[_vm._v("00 01 ... 22 23")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"even"},[_c('td'),_c('td',[_c('strong',[_vm._v("h")])]),_c('td',[_vm._v("1 2 ... 12")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"even"},[_c('td'),_c('td',[_c('strong',[_vm._v("hh")])]),_c('td',[_vm._v("01 02 ... 12")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("m")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"odd"},[_c('td'),_c('td',[_c('strong',[_vm._v("mm")])]),_c('td',[_vm._v("00 01 ... 58 59")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("s")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"even"},[_c('td'),_c('td',[_c('strong',[_vm._v("ss")])]),_c('td',[_vm._v("00 01 ... 58 59")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("S")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"odd"},[_c('td'),_c('td',[_c('strong',[_vm._v("SS")])]),_c('td',[_vm._v("00 01 ... 98 99")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"odd"},[_c('td'),_c('td',[_c('strong',[_vm._v("SSS")])]),_c('td',[_vm._v("000 001 ... 998 999")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Z")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"even"},[_c('td'),_c('td',[_c('strong',[_vm._v("ZZ")])]),_c('td',[_vm._v("-0700 -0600 ... +0600 +0700")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("w")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"odd"},[_c('td'),_c('td',[_c('strong',[_vm._v("ww")])]),_c('td',[_vm._v("01 02 ... 52 53")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("X")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("x")])])}]

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DateFormatsInfoModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__